import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  Typography,
  Card,
  CardContent,
  CardActions,
  Dialog,
  DialogContent,
  DialogActions,
  Slider,
  IconButton,
  TextField,
} from "@mui/material";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "../style/cards.css";
import { AttachFile } from "@mui/icons-material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "../login/Login.css";

const TaskUpdate = () => {
  const [open, setOpen] = useState(false);
  const [progress, setProgress] = useState(0);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadingFiles, setLoadingFiles] = useState({}); // Track loading per file

  // const [tasks, setTasks] = useState([]);
  const [tasks, setTasks] = useState({
    pending: [],
    ongoing: [],
    inreview: [],
    completed: [],
  });
  const [admin, setAdmin] = useState([]);
  const [project, setProject] = useState([]);
  const [employee, setEmployees] = useState([]);
  const [subtask, setSubTasks] = useState([]);
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [descriptionDialogOpen, setDescriptionDialogOpen] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null); // Reference for file input
  const userData = JSON.parse(localStorage.getItem("user"));
  const userId = userData?.id;
  const [recentUpdates, setRecentUpdates] = useState(new Set()); //state for recetupdated subtask
  const getDueDateColor = (toDate) => {
    if (!toDate) {
      // alert("ToDate is missing!"); // Shows alert if the date is missing
      return "#666"; // Default color if no date is provided
    }
    // alert("Received ToDate: " + toDate); // Show the date before processing
    // Convert "DD-MM-YYYY" to "YYYY-MM-DD" for correct Date parsing
    const [day, month, year] = toDate.split("-");
    const formattedDate = new Date(`${year}-${month}-${day}T00:00:00`);
    if (isNaN(formattedDate)) {
      // alert("Invalid Date Format: " + toDate); //Show error alert
      return "#666"; // Return default if date is invalid
    }
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Remove time from system date
    const timeDiff = formattedDate - currentDate;
    const daysRemaining = timeDiff / (1000 * 60 * 60 * 24); // Convert to days
    // alert("Days Remaining: " + daysRemaining); //  Show days difference
    if (daysRemaining === 0) {
      return "green"; //  Task is due today
    } else if (daysRemaining < 0) {
      return "red"; //  Missed Deadline (Past Date)
    } else if (daysRemaining <= 2) {
      return "orange"; //  Due in 2 Days or Less
    } else {
      return "black"; // Normal
    }
  };
  const extractToDate = (taskDuration) => {
    if (!taskDuration) return null; // If empty, return null
    const dates = taskDuration.split(" - "); // Split by " - "
    return dates.length > 1 ? dates[1] : null; // Return the second date (ToDate)
  };

  //fetch tasks from API
  const fetchTasks = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://aligndesk.dropyourbusiness.com/api/task/employee/${userId}`
      );
      const allTasks = response.data.task;
      const taskData = allTasks.map((t, index) => ({
        TaskId: t.project_task_id || `temp-${index}`, // Assign a fallback ID if missing
        ProjectId: t.project_task_project_id,
        TaskAssignTo: t.project_task_assignto,
        TaskAssignBy: t.project_task_assignby,
        Priority: t.project_task_priority,
        TaskTitle: t.project_task_title,
        TaskDescription: t.project_task_Description,
        TaskDuration: t.project_task_duration,
        TaskIsStart: t.project_task_isstart,
        TaskIsCompleted: t.project_task_iscompleted,
        TaskIsActive: t.project_task_isactive,
        TaskStatus: t.project_task_status,
        TaskFile: t.project_task_attach_file,
      }));
      // Fix: Categorize tasks correctly
      const categorizedTasks = {
        Pending: taskData.filter(
          (t) => t.TaskStatus === "Pending" || t.TaskStatus === "on hold"
        ),
        Ongoing: taskData.filter((t) => t.TaskStatus === "Ongoing"),
        InReview: taskData.filter((t) => t.TaskStatus === "InReview"),
        Completed: taskData.filter((t) => t.TaskStatus === "Completed"),
      };
      console.log("taskData-->", taskData);
      setTasks(categorizedTasks); // Fix: Now setting categorized tasks correctly
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchTasks(); // Initial fetch
    const interval = setInterval(() => {
      fetchTasks();
    }, 60 * 60 * 1000); // 1 hour = 60 min * 60 sec * 1000 ms
    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const fetchAdmin = async () => {
    setLoading(true);
    try {
      const adminResponse = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/admin"
      );
      const adminData = adminResponse.data.admin.map((a) => ({
        Admin_id: a.admin_id,
        FullName: a.admin_fullname,
      }));
      setAdmin(adminData);
    } catch (error) {
      console.error("Error fetching admin data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchAdmin();
  }, []);

  const fetchSubTasks = async (TaskId) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://aligndesk.dropyourbusiness.com/api/subtasks/projecttask/${TaskId}`
      );
      if (response.status === 200) {
        // If tasks are found, update the subtask list
        const subTaskData = response.data.subtasks.map((t) => ({
          TUM_Id: t.task_update_id,
          TUM_PTM_Id: t.task_ptm_id,
          TUM_UpdatedBy: t.task_Updateby,
          TUM_Progress: t.task_progress,
          TUM_Comment: t.task_comment,
          TUM_IsActive: t.task_isactive,
          TUM_Attach_File: t.task_attach_file,
          created_at: t.task_created_at,
          updated_at: t.task_updated_at,
        }));
        setSubTasks(subTaskData.reverse());
      } else if (
        response.status === 404 &&
        response.data.message === "No Subtasks found for the given employee."
      ) {
        console.log("No sub-tasks found. Adding a new task...");
        await handleAddSubTask(TaskId);
      }
    } catch (error) {
      console.error("Error fetching subtasks:", error);
    }
    setLoading(false);
  };

  // Fetch Project data from the API
  const fetchProject = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/projects"
      );
      const projectData = response.data.project.map((project) => ({
        ProjectId: project.project_id,
        ProjectName: project.project_name,
      }));
      console.log("project-->", projectData.ProjectName);
      setProject(projectData);
    } catch (error) {
      console.error("Error fetching project data:", error);
      //   toast.error("Error fetching employee data.");
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchProject();
  }, []);

  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/emp"
      );
      console.log(response);
      // Filter both employees and managers
      const employeeData = response.data.employees
        .filter(
          (emp) =>
            emp.employee_role === "E" ||
            emp.employee_role === "M" ||
            emp.employee_role === "T"
        ) // Include both roles
        .map((emp) => ({
          Employee_id: emp.employee_id,
          EmployeeName: `${emp.employee_first_name} ${emp.employee_last_name}`, // Full name
          Role: emp.employee_role, // Include role for reference
        }));
      console.log("Filtered employees & managers:", employeeData);
      setEmployees(employeeData);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchEmployees();
  }, []);

  // Handle drag event
  const handleDragEnd = async (result) => {
    if (!result.destination) return;
    const { source, destination } = result;
    const sourceColumn = source.droppableId;
    const destinationColumn = destination.droppableId;
    if (sourceColumn === "Completed" || destinationColumn === "Completed")
      return; // Do not drag tasks into Completed
    // Prevent dragging tasks in Completed column
    if (sourceColumn === "Completed") return;
    const movedTask = tasks[sourceColumn][source.index];
    // Remove from source column
    const updatedSourceTasks = [...tasks[sourceColumn]];
    updatedSourceTasks.splice(source.index, 1);
    // Add to destination column
    const updatedDestinationTasks = [...tasks[destinationColumn], movedTask];
    setTasks((prevTasks) => ({
      ...prevTasks,
      [sourceColumn]: updatedSourceTasks,
      [destinationColumn]: updatedDestinationTasks,
    }));
    // If moved to "Completed", notify admin for approval
    if (destinationColumn === "InReview") {
      try {
        await axios.put(
          `https://aligndesk.dropyourbusiness.com/api/task/${movedTask.TaskId}/status`,
          { project_task_status: "InReview" }
        );
        toast.success("Task marked as InReview. Waiting for admin approval.");
        fetchTasks();
      } catch (error) {
        console.error("Error updating task status:", error);
        toast.error("Failed to update task status.");
      }
    } else {
      try {
        await axios.put(
          `https://aligndesk.dropyourbusiness.com/api/task/${movedTask.TaskId}/status`,
          { project_task_status: destinationColumn }
        );
        toast.success("Task Status Updated!");
        fetchTasks();
      } catch (error) {
        console.error("Error updating task status:", error);
        toast.error("Failed to update task status.");
      }
    }
  };

  const handleAddSubTask = async (TaskId) => {
    const payload = {
      task_ptm_id: TaskId,
      task_Updateby: userId,
      task_progress: "0", // Start progress at 0
      task_comment: "",
      task_isactive: true,
      task_attach_file: selectedFile ? selectedFile : "",
      task_created_at: "",
      task_updated_at: "",
    };
    try {
      const response = await axios.post(
        "https://aligndesk.dropyourbusiness.com/api/subtask/add",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.status === 200) {
        toast.success("Your Progress Updated!");
        fetchSubTasks(TaskId); // Fetch again to update state
      } else {
        toast.error("Failed to create subtask.");
      }
    } catch (error) {
      console.error("Error creating subtask:", error);
      toast.error("Error creating subtask.");
    }
  };

  // const handleProgressChange = (e, val) => {
  //   setProgress((prevProgress) => Math.max(prevProgress, val)); // Prevent decreasing progress
  // };

  // Handle Submit Button Click
  const handleSubmit = async () => {
    const payload = {
      task_ptm_id: selectedTaskId,
      task_Updateby: userId,
      task_progress: progress.toString(),
      task_comment: comment,
      task_isactive: true,
      task_attach_file: "", // Keeping it empty as in your example
      task_created_at: "",
      task_updated_at: "",
    };
    try {
      const response = await fetch(
        "https://aligndesk.dropyourbusiness.com/api/subtask/add",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();
      if (response.ok) {
        toast.success("Data submitted successfully!");
        setOpen(false);
        fetchTasks();
      } else {
        alert(`Failed to submit: ${result.message || "Unknown error"}`);
      }
    } catch (error) {
      alert("Error submitting data: " + error.message);
    }
  };
  // Open description dialog
  const handleSeeMore = (fullDescription) => {
    setSelectedDescription(fullDescription);
    setDescriptionDialogOpen(true);
  };
  // Open dialog & fetch subtasks
  const handleViewSubTasks = async (taskId) => {
    setSubTasks([]);
    setSelectedTaskId(taskId);
    setOpen(true);
    fetchSubTasks(taskId);
  };

  // Handle File Upload
  const handleFileUpload = async (event, selectedTUMId) => {
    const file = event.target.files[0];
    if (!file) return;

    setLoadingFiles((prev) => ({ ...prev, [selectedTUMId]: true })); // Start loader for the specific task
    setSelectedFile(file);
    setSelectedTaskId(selectedTUMId);

    const formData = new FormData();
    formData.append("task_update_id", selectedTUMId);
    formData.append("task_Updateby", userId);
    formData.append("task_progress", progress.toString());
    formData.append("task_comment", comment);
    formData.append("task_isactive", true);
    formData.append("task_attach_file", file);
    formData.append("task_updated_at", new Date().toISOString());

    try {
      const response = await axios.post(
        `https://aligndesk.dropyourbusiness.com/api/subtask/add-attachment/${selectedTUMId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.status === 200 || response.status === 201) {
        toast.success("File uploaded successfully!");
        fetchSubTasks(selectedTUMId);
      } else {
        toast.error("Failed to upload file.");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      toast.error(
        "File Type Must Be: pdf, doc, docx, xlsx, csv, txt, png, jpg, jpeg"
      );
    } finally {
      setLoadingFiles((prev) => ({ ...prev, [selectedTUMId]: false })); // Stop loader for the specific task
    }
  };

  // Function to handle status update
  const handleStatusChange = async (taskId, newStatus) => {
    console.log("status-->", newStatus);
    if (!newStatus) {
      toast.error("Invalid status update");
      return;
    }
    try {
      const response = await axios.put(
        `https://aligndesk.dropyourbusiness.com/api/task/${taskId}/status`,
        { project_task_status: newStatus },
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.status === 200) {
        toast.success("Task status updated successfully!");
        fetchTasks(); // Refresh task list after update
      } else {
        toast.error("Failed to update task status.");
      }
    } catch (error) {
      console.error("Error updating task status:", error);
      toast.error("Error updating task status.");
    }
  };
  // Identify newly updated subtasks
  useEffect(() => {
    if (subtask.length > 0) {
      // Identify newly updated subtasks (where updated_at has changed)
      const updatedTaskIds = new Set(
        subtask
          .filter((st) => new Date(st.updated_at) > Date.now() - 30000) // Tasks updated within 1 min
          .map((st) => st.TUM_Id)
      );
      setRecentUpdates(updatedTaskIds);
      // Remove highlight after 1 minute
      const timer = setTimeout(() => {
        setRecentUpdates(new Set());
      }, 30000);
      return () => clearTimeout(timer);
    }
  }, [subtask]); // Runs whenever `subtask` updates
  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <ToastContainer />
      <div className="task-container">
        {Object.entries(tasks).map(([status, taskList]) => (
          <Droppable key={status} droppableId={status}>
            {(provided) => (
              <div
                className="task-column"
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                <h3>{status.toUpperCase()}</h3>
                {taskList.map((task, index) =>
                  task.TaskId ? (
                    <Draggable
                      key={task.TaskId}
                      draggableId={task.TaskId.toString()}
                      index={index}
                      isDragDisabled={status === "Completed"}
                    >
                      {(provided) => (
                        <Card
                          ref={provided.innerRef}
                          {...(status !== "Completed"
                            ? provided.draggableProps
                            : {})}
                          {...(status !== "Completed"
                            ? provided.dragHandleProps
                            : {})}
                          className={`task-card task-status-${
                            task.TaskStatus?.toLowerCase() || "default"
                          }`}
                        >
                          <CardContent>
                            <Typography variant="h6" fontWeight="bold">
                              {task.TaskTitle}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                              Project:{" "}
                              <strong>
                                {project.find(
                                  (p) => p.ProjectId === task.ProjectId
                                )?.ProjectName || "Unknown Project"}
                              </strong>
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              color="textSecondary"
                            >
                              Assigned By:{" "}
                              <strong>
                                {" "}
                                {employee.some(
                                  (emp) => emp.Employee_id === task.TaskAssignBy
                                )
                                  ? employee.find(
                                      (emp) =>
                                        emp.Employee_id === task.TaskAssignBy
                                    )?.EmployeeName
                                  : admin.find(
                                      (a) => a.Admin_id === task.TaskAssignBy
                                    )?.FullName || "Unknown"}
                              </strong>
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              color="textSecondary"
                            >
                              Priority:
                              <Box
                                className={`priority-badge priority-${
                                  task.Priority?.toLowerCase() || "default"
                                }`}
                              >
                                {task.Priority}
                              </Box>
                            </Typography>
                            <Typography
                              variant="body2"
                              color="textSecondary"
                              sx={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 1,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              Description:{" "}
                              {task.TaskDescription ||
                                "No description available"}
                            </Typography>
                            {task.TaskDescription &&
                              task.TaskDescription.split(" ").length > 10 && (
                                <Button
                                  size="small"
                                  onClick={() =>
                                    handleSeeMore(task.TaskDescription)
                                  }
                                >
                                  See More
                                </Button>
                              )}
                            <Typography
                              variant="body2"
                              style={{
                                color: getDueDateColor(
                                  extractToDate(task.TaskDuration)
                                ),
                              }}
                            >
                              Duration:{" "}
                              {task.TaskDuration
                                ? task.TaskDuration
                                : "Date not available"}
                            </Typography>
                            {task.TaskFile && (
                              <img
                                src="../images/file.png" // Replace with your image path
                                alt="Open File"
                                className="open-file-icon"
                                onClick={() =>
                                  window.open(task.TaskFile, "_blank")
                                }
                              />
                            )}
                          </CardContent>
                          {task.TaskStatus === "Ongoing" && (
                            <CardActions>
                              <Button
                                variant="contained"
                                color="primary"
                                className="progressbtn"
                                onClick={() => handleViewSubTasks(task.TaskId)}
                              >
                                Current Progress
                              </Button>
                            </CardActions>
                          )}
                        </Card>
                      )}
                    </Draggable>
                  ) : null
                )}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        ))}
        <Box>
          {/* Dialog for Full Description */}
          <Dialog
            open={descriptionDialogOpen}
            onClose={() => setDescriptionDialogOpen(false)}
          >
            <DialogContent>
              <Typography variant="h6">Task Description</Typography>
              <Typography variant="body2">{selectedDescription}</Typography>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setDescriptionDialogOpen(false)}
                style={{
                  background: "red",
                  color: "white",
                }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </div>
      {/* Dialog for Updating Progress */}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogContent>
          <Typography variant="h6">Update Progress</Typography>
          <Slider
            value={progress}
            onChange={(e, val) => setProgress(val)}
            min={0}
            max={100}
            step={10}
            valueLabelDisplay="auto"
          />
          <Typography>Progress: {progress}%</Typography>
          <br />
          <TextField
            label="Task Comment"
            // name="project_task_title"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            // disabled={editMode} //Disable when editing
            fullWidth
          />
          <br />
          {/* Subtasks Section - Display only the latest update */}
          {subtask.length > 0 && (
            <Box>
              <Typography variant="subtitle1">Previous Updates:</Typography>
              {subtask.map((st) => (
                <Box
                  key={st.TUM_Id}
                  sx={{
                    marginBottom: "10px",
                    padding: "10px",
                    border: "2px solid #ccc",
                    backgroundColor: recentUpdates.has(st.TUM_Id)
                      ? "#ffff99"
                      : "transparent", // Highlight only updated tasks
                    transition: "background-color 0.5s ease-in-out",
                  }}
                >
                  <Typography>
                    {st.updated_at && st.updated_at !== st.created_at
                      ? `Update Date: ${st.updated_at}`
                      : `Created Date: ${st.created_at}`}
                  </Typography>
                  {/* Display Updated By */}
                  {st.TUM_UpdatedBy && st.updated_at && (
                    <Typography>Updated By: {" "}
                    {employee.some(
                      (emp) => emp.Employee_id === st.TUM_UpdatedBy
                    )
                      ? employee.find(
                        (emp) =>
                          emp.Employee_id === st.TUM_UpdatedBy
                      )?.EmployeeName
                      : admin.find(
                        (a) => a.Admin_id === st.TUM_UpdatedBy
                      )?.FullName || "Unknown"}</Typography>
                  )}
                  <Typography>Progress: {st.TUM_Progress}%</Typography>
                  <Typography>Comment: {st.TUM_Comment}</Typography>
                  {/* Show the attached file if available */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      // mt: 1,
                    }}
                  >
                    <Typography variant="body2">
                      <label htmlFor="file-upload">Upload File:</label>
                    </Typography>
                    <IconButton component="label">
                      <AttachFile style={{ padding: "0px" }} />
                      <input
                        type="file"
                        hidden
                        id={`file-upload-${st.TUM_Id}`} // Unique ID for each subtask
                        ref={fileInputRef}
                        onChange={(event) => handleFileUpload(event, st.TUM_Id)} // Pass the correct subtask ID
                      />
                      {loadingFiles[st.TUM_Id] && ( // Show loader only for the specific file
                        <div className="login-loader-container">
                          <div className="login-loader"></div>
                        </div>
                      )}
                    </IconButton>
                  </Box>
                  {/* Attached File Section */}
                  {st.TUM_Attach_File && (
                    <Typography variant="body2">
                      <a
                        href={st.TUM_Attach_File}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          textDecoration: "none",
                          color: "black",
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <img
                          src="../images/file.png"
                          alt="Preview"
                          style={{ width: "20px", height: "20px" }}
                        />
                      </a>
                    </Typography>
                  )}
                </Box>
              ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions style={{ justifyContent: "space-between" }}>
          <Button
            onClick={handleSubmit}
            style={{ background: "#007bff", color: "white" }}
          >
            Submit
          </Button>
          <Button
            onClick={() => setOpen(false)}
            style={{ background: "red", color: "white" }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </DragDropContext>
  );
};
export default TaskUpdate;
